import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { IApplication, IProduct, IStep } from '../../models';
import {
  handleNextClick,
  handlePreviousClick,
  handleShowResultsClick
} from '../../redux/actions/appActions';
import { IApplicationState } from '../../redux/reducers/rootReducer';
import {
  getFilteredProducts,
  getProducts,
  getStep
} from '../../redux/selectors';
import ComponentFactory from '../ComponentFactory';
import Title from '../Title';
import StepNavigation from './StepNavigation';

const Container = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
`;

const ResultsText = styled.a`
    display: flex;
    justify-content: center;
    color: black;
`;

interface IStoreProps {
  application: IApplication | null;
  inputs: Map<string, string>;
  stepIndex: number;
  step: IStep | null;
  products: IProduct[];
  filteredProducts: IProduct[];
}

interface IDispatchProps {
  handleNextClick: (filters: Map<string, string>) => void;
  handlePreviousClick: () => void;
  handleShowResultsClick: () => void;
}

interface IState {
  uiState: Map<string, string>;
}

class Step extends React.Component<IStoreProps & IDispatchProps, IState> {
  state = {
    uiState: new Map<string, string>(this.props.inputs)
  };

  products = this.props.filteredProducts;

  addUiStateItem = (key: string, value: string) => {
    const uiState = this.state.uiState;
    uiState.set(key, value);

    this.setState({
      uiState
    });
  }

  render() {
    const {
      application,
      step,
      stepIndex,
      handlePreviousClick,
      handleNextClick,
      handleShowResultsClick,
      filteredProducts
    } = this.props;

    const { uiState } = this.state;

    if (!step) return null;

    return (
      <Container>
        <Title title={step.name} subtitle={step.subtitle} />
        {step.filters.map(
          (filter) => ComponentFactory.build(
            filter,
            filteredProducts,
            uiState,
            this.addUiStateItem))}
        <ResultsText href={'#'} onClick={() => handleShowResultsClick()}>
          {filteredProducts.length} results remaining
        </ResultsText>
        <StepNavigation
          application={application}
          stepIndex={stepIndex}
          inputs={uiState}
          handlePreviousClick={() => {
            const keyToRemove = Array.from(uiState.keys()).pop();
            if (keyToRemove !== undefined && keyToRemove !== step.name) {
              uiState.delete(keyToRemove);
            }
            handlePreviousClick();
          }}
          handleNextClick={() => {
            const keyToRemove = Array.from(uiState.keys()).pop();
            if (keyToRemove !== undefined && keyToRemove !== step.name) {
              uiState.delete(keyToRemove);
            }

            handleNextClick(uiState);
          }}
        />
      </Container >
    );
  }
}

const mapStateToProps = (state: IApplicationState) => {
  return {
    application: state.appReducer.application,
    inputs: state.appReducer.inputs,
    stepIndex: state.appReducer.stepIndex,
    step: getStep(state),
    products: getProducts(state),
    filteredProducts: getFilteredProducts(state)
  };
};

const actions: IDispatchProps = {
  handleNextClick,
  handlePreviousClick,
  handleShowResultsClick
};

export default connect(mapStateToProps, actions)(Step);
